// Duck structure from https://github.com/alexnm/re-ducks/

import reducer from './reducer';
import * as actions from './actions';
import * as types from './types';

export { actions, types };

export default reducer;
